(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function track(event, params) {
    if (window.tcbAnalytics && typeof window.tcbAnalytics.track === 'function') {
      window.tcbAnalytics.track(event, params || {});
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-tcb-supplier-partnerships]');
    if (!root) return;

    root.querySelectorAll('[data-tcb-scroll]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.querySelector(el.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    root.querySelectorAll('[data-tcb-sp-track]').forEach(function (el) {
      el.addEventListener('click', function () {
        var eventName = el.getAttribute('data-tcb-sp-track');
        var brand = el.getAttribute('data-tcb-sp-brand');
        var params = brand ? { brand: brand } : {};
        track(eventName, params);
      });
    });
  });
})();
